import { render } from "./SqlQuery.vue?vue&type=template&id=908c81da&scoped=true"
import script from "./SqlQuery.vue?vue&type=script&lang=js"
export * from "./SqlQuery.vue?vue&type=script&lang=js"

import "./SqlQuery.vue?vue&type=style&index=0&id=908c81da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908c81da"]])

export default __exports__